import { render } from "./OptionBased.vue?vue&type=template&id=04e5f0e7&scoped=true"
import script from "./OptionBased.vue?vue&type=script&lang=js"
export * from "./OptionBased.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-04e5f0e7"

export default script